import { Box } from '@react-three/drei';
import { useLoader } from '@react-three/fiber';
import { TextureLoader, RepeatWrapping, SRGBColorSpace } from 'three';
import { useMemo, useEffect } from 'react';

// Composant générique qui applique la texture avec repeat spécifique
function TexturedBox({ args, position, maps, repeatX, repeatY }) {
  // ✅ Cloner les textures une seule fois
  const [colorMap, roughnessMap,metalnessMap, normalMap, displacementMap, aoMap] = useMemo(
    () => maps.map((map) => (map ? map.clone() : null)),
    [maps] // seulement quand maps change (jamais dans ton cas)
  );

  // Configurer le repeat après le clone
  useEffect(() => {
    [colorMap, roughnessMap,metalnessMap, normalMap, displacementMap, aoMap].forEach((map, i) => {
      if (!map) return;
      map.wrapS = map.wrapT = RepeatWrapping;
      map.repeat.set(repeatX, repeatY);
      if (i === 0) map.colorSpace = SRGBColorSpace; // seulement la couleur
      map.needsUpdate = true;
    });
  }, [colorMap, roughnessMap,metalnessMap, normalMap, displacementMap, aoMap, repeatX, repeatY]);

  return (
    <Box args={args} position={position} receiveShadow>
      <meshStandardMaterial
        map={colorMap}
        roughnessMap={roughnessMap}
        metalnessMap={metalnessMap}
        normalMap={normalMap}
        displacementMap={displacementMap}
        aoMap={aoMap} 
        displacementIntensity={-0.2} 
      />
    </Box>
  );
}

export default function Room() {

  const maps = useLoader(TextureLoader, [
    './textures/damaged_brown/damaged_brown_diffuse.jpg',
    './textures/damaged_brown/damaged_brown_roughness.jpg',
    './textures/damaged_brown/damaged_brown_glossiness.jpg',
    './textures/damaged_brown/damaged_brown_normal.jpg',
    './textures/damaged_brown/damaged_brown_height.jpg',
    './textures/damaged_brown/damaged_brown_ao.jpg',
  ]);

  return (
    <>
      {/* plafond */}
      <mesh  position={[0,8.1,0]}>
        <boxGeometry args={[100, 0.1, 100]}/>
        <meshStandardMaterial color={"#111111"}  roughness={1} metalness={1}/>
      </mesh>

      {/* droite */}
      <mesh  position={[-50, 3.3, 0]}>
        <boxGeometry args={[0.1, 10, 100]}/>
        <meshStandardMaterial color={"#111111"}  roughness={1} metalness={0.9}/>
      </mesh>

      {/* gauche */}
      <mesh  position={[50, 3.3, 0]}>
        <boxGeometry args={[0.1, 10, 100]}/>
        <meshStandardMaterial color={"#111111"}  roughness={1} metalness={0.9}/>
      </mesh>

      {/* devant */}
      <mesh  position={[0, 3.3, 50]}>
        <boxGeometry args={[100, 10, 0.1]}/>
        <meshStandardMaterial color={"#111111"}  roughness={1} metalness={0.9}/>
      </mesh>

      {/* derrière */}
      <mesh  position={[0, 3.3, -50]}>
        <boxGeometry args={[100, 10, 0.1]}/>
        <meshStandardMaterial color={"#111111"}  roughness={1} metalness={0.9}/>
      </mesh>

      {/* sol */}
      <mesh  position={[0,-1.66,0]}>
        <boxGeometry args={[100, 0.1, 100]}/>
        <meshStandardMaterial color={"#111111"}  roughness={0.6} metalness={0.2}/>
      </mesh>
    </>
  );
}
